var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.726,
    height: 35.726,
    viewBox: "0 0 35.726 35.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9151",
    "data-name": "Group 9151",
    transform: "translate(-322.787 -697.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_303",
    "data-name": "Ellipse 303",
    transform: "translate(322.787 697.787)",
    fill: "#000",
    stroke: "#ef7b13",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.863,
    cy: 17.863,
    r: 17.863,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.863,
    cy: 17.863,
    r: 17.363,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "share-svgrepo-com",
    d: "M14.433,2.25a2.745,2.745,0,0,0-2.7,3.228L7.74,8.272a.639.639,0,0,0-.058.045,2.743,2.743,0,1,0,0,4.322.637.637,0,0,0,.058.045l3.993,2.795a2.744,2.744,0,1,0,.521-1.181L8.473,11.653a2.75,2.75,0,0,0,0-2.348l3.781-2.646a2.743,2.743,0,1,0,2.18-4.408ZM12.956,4.993A1.477,1.477,0,1,1,14.433,6.47,1.477,1.477,0,0,1,12.956,4.993ZM5.993,9A1.477,1.477,0,1,0,7.47,10.479,1.477,1.477,0,0,0,5.993,9Zm8.44,5.486a1.477,1.477,0,1,0,1.477,1.477A1.477,1.477,0,0,0,14.433,14.488Z",
    transform: "translate(329.62 704.53)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a97034b7d1c96053c48179993be168b8.svg";
export { ForwardRef as ReactComponent };